import { SAMPLE_PASSWORD } from '../tools/constants'
import { api } from './api'

// 신청서 저장
const setApply = data =>
  new Promise((resolve, reject) => {
    data = { ...data, parent_code: data.parent_code, bizTrans: new URLSearchParams(window.location.search).get('bizTrans') }

    api
      .post('/api/v1/apply/applyRegi', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...data, ...resDate.data }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data }
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

// 출금계좌 변경 신청서 정보가져오기
const getModiShopInfo = data =>
  new Promise((resolve, reject) => {
    data = { ...data, shop_code: data.shop_code }

    api
      .post('/api/v1/shop/accountModiShopInfo', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...data, ...resDate.data }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data }
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

// 출금계좌 변경 신청서 정보가져오기
const setApplyUpdt = data =>
  new Promise((resolve, reject) => {
    data = {
      shop_token: data.shop_token, //"가맹점토큰",
      shop_idx: data.shop_idx, //"가맹점일련번호",
      payment_idx: data.payment_idx, //"출금일련번호",
      biz_no: data.biz_no, //"사업자등록번호",
      shop_name: data.shop_name, //"사업자명",
      owner_name: data.owner_name, //"대표자명",
      owner_phone_no: data.owner_phone_no, //"대표자휴대폰",
      bank_code: data.bank_code, //"은행코드",
      bank_name: data.bank_name, //"은행명",
      account_name: data.account_name, //"예금주명",
      account_no: data.account_no, //"계좌번호",
      account_jumin_biz_no: data.account_jumin_biz_no, //"예금주-생년월일or사업자번호",
      account_phone_no: data.account_phone_no, //"예금주휴대폰",
      agree_yn: data.agree_yn, //"약관동의여부",
      apply_name: data.apply_name, //"신청자명",
      apply_phone_no: data.apply_phone_no, //"신청자휴대폰",
      account_relation: data.account_relation, //"예금주와의관계",
      apply_file: data.apply_file //"신청서파일(base64String)"
    }

    api
      .post('/api/v1/apply/applyUpdt', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...data, ...resDate.data }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data }
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

// 사업자 번호 인증
const applyBizNoValid = (data, endpoint) =>
  new Promise((resolve, reject) => {
    api
      .post(endpoint || '/api/v1/apply/applyBizNoValid', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code || resDate.result_code === '00000') {
          data = { ...data, ...resDate.data, result_code: resDate.result_code, payload: resDate.payload }
          resolve(data)
        } else if (resDate.result_code === 'E02005') {
          alert(resDate.result_msg)
          // data = { ...data, ...resDate.data }
          // reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
        alert(error?.message)
      })
  })

const applyFranchiseRegi = data =>
  new Promise((resolve, reject) => {
    data = {
      // This manager of Sponge R
      manager_idx: data.manager_idx,

      franchise_name: data.franchisee_name,
      biz_no: data.biz_no,
      representative_name: data.owner_name,

      manager_id: data.id,
      manager_password: data.password === SAMPLE_PASSWORD ? '' : data.password,
      manager_name: data.contact_manager_name,
      manager_phone_no: data.owner_phone_no,
      manager_email: data.contact_manager_email,
      upload_file_count: data.upload_file_count,
      apply_file: data.apply_file,

      // keys that starts with 'upload_file'. eg. upload_file1, upload_file2
      ...Object.keys(data).reduce((acc, key) => {
        if (key.startsWith('upload_file')) {
          acc[key] = data[key]
        }
        return acc
      }, {})
    }

    // console.log(data);
    // return;

    api
      .post('/api/v1/apply/applyFranchiseRegi', data)
      .then(response => {
        const resData = response.data
        if (resData.result_code === '00000') {
          data = { ...data, ...resData.data }
          resolve(data)
        } else {
          data = { ...data, ...resData.data }
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

const getShopInfo = shopIdx =>
  new Promise((resolve, reject) => {
    api
      .get(`/api/v1/apply/info/${shopIdx}`)
      .then(response => {
        const resData = response.data
        if (resData.result_code || resData.result_code === '00000') {
          resolve(resData.data)
        } else {
          alert(resData.result_msg)
          // data = { ...data, ...resDate.data }
          // reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
        alert(error?.message)
      })
  })
const apiConfirmJoinFranchise = async data => {
  return new Promise((resolve, reject) => {
    api
      .post('/api/v1/apply/confirmJoinFranchise', data)
      .then(response => {
        const resData = response.data
        if (resData.result_code === '00000') {
          data = { ...data, ...resData.data }
          resolve(data)
        } else {
          data = { ...data, ...resData.data }
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })
}
const apiSendShopCfConfirmViaKakao = async data => {
  return new Promise((resolve, reject) => {
    api
      .post('/api/v1/apply/sendShopCfConfirmViaKakao', data)
      .then(response => {
        const resData = response.data
        if (resData.result_code === '00000') {
          data = { ...data, ...resData.data }
          resolve(data)
        } else {
          data = { ...data, ...resData.data }
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })
}

const applyToAnotherFranchise = async data => {
  return new Promise((resolve, reject) => {
    api
      .post('/api/v1/apply/applyToAnotherFranchise', data)
      .then(response => {
        const resData = response.data
        if (resData.result_code === '00000') {
          data = { ...data, ...resData.data }
          resolve(data)
        } else {
          data = { ...data, ...resData.data }
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })
}

const verifyBizNoShopCode = data =>
  new Promise((resolve, reject) => {
    api
      .post('/api/v1/shop/verifyBizNoShopCode', data)
      .then(response => {
        const resData = response.data
        if (resData.result_code === '00000') {
          data = { ...data,shop_name: resData.shop_name, result_code: resData.result_code }
          resolve(data)
        }
        else{
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
        alert(error?.message)
      })
    })

const applyConfig = {
  setApply,
  getModiShopInfo,
  setApplyUpdt,
  applyBizNoValid,
  applyFranchiseRegi,
  getShopInfo,
  apiConfirmJoinFranchise,
  apiSendShopCfConfirmViaKakao,
  applyToAnotherFranchise,
  verifyBizNoShopCode
}

export { applyConfig }
